import { apiClientPrivate } from "../adapters/api";

export async function viewFileFromS3(key) {
  const response = await apiClientPrivate.get(`/get-download-url?key=${encodeURIComponent(key)}`);
  const { signedUrl } = response.data;

  return signedUrl;
}
